import FastAdd from './src/main'

FastAdd.install = function (Vue) {
  Vue.component(FastAdd.name, FastAdd)
}

export default FastAdd
